import { ClassName } from '@busybusy/webapp-react-ui';
import { CertificationForm, ICertificationFormData } from '../CertificationForm/CertificationForm';
import classNames from 'classnames';
import { HeaderDialog } from 'components';
import { t } from 'i18next';
import { ManageCertificationsTableData } from '../ManageCertificationsTable/ManageCertificationsTable';
import { getMonthsYearsFromRenewalPeriod } from '../utils';

export interface IEditCertificationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onEdit: (data: ICertificationFormData) => void;
  certification: ManageCertificationsTableData;
  onDelete: () => void;
  className?: ClassName;
}

export const EditCertificationDialog = (props: IEditCertificationDialogProps) => {
  const { isOpen, onClose, onEdit, certification, onDelete, className } = props;

  const classes = classNames('edit-certification-dialog', className);

  const { months, years } = getMonthsYearsFromRenewalPeriod(certification);

  const formData: ICertificationFormData = {
    name: certification.name,
    description: certification.description ?? undefined,
    renewalRequired: certification.renewalRequired,
    employeeCanManage: certification.employeeCanManage,
    documentationRequired: certification.documentationRequired,
    expiredAfterMonths: months,
    expiredAfterYears: years,
  };

  return (
    <HeaderDialog isOpen={isOpen} onClose={onClose} title={t('Edit Certification')} divider={false} className={classes}>
      <CertificationForm onFormSubmit={onEdit} edit={true} formData={formData} onDelete={onDelete} />
    </HeaderDialog>
  );
};
